import { useReducer } from 'react';

export const UPDATE = 'update';
export const RESET = 'reset';

export const updateState = (payload) => ({ payload, type: UPDATE });
export const clearState = (payload) => ({ payload, type: RESET });

/**
 * Provides a simple reducer to allow components
 * local state to be updated with `useReducer`
 * hooks
 *
 * @param {Object} state
 * @param {Object} action
 * @param {string} action.type
 * @param {any} [action.payload]
 * @returns {Object} state
 */
export const localStateReducer = (state, action) => {
  switch (action.type) {
    case UPDATE:
      return Object.assign(
        {},
        state,
        action.payload
      );
    case RESET:
      return Object.assign(
        {},
        action.payload
      );
    default:
      return state;
  }
};

/**
 * Provides action dispatchers for `localStateReducer`
 * in a hook interface
 *
 * @param {Object} initialState
 * @param {function(*, *)} reducer
 * @returns {[Object, Function, Function]}
 */
export const useLocalStateReducer = (initialState = {}, reducer = localStateReducer) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const setState = payload => dispatch(updateState(payload));
  const resetState = () => dispatch(clearState(initialState));

  return [state, setState, resetState];
};

export default localStateReducer;
